import Vue from 'vue';
import {
  AlertPlugin,
  BadgePlugin,
  BootstrapVueIcons,
  CardPlugin,
  ButtonPlugin,
  ImagePlugin,
  InputGroupPlugin,
  FormCheckboxPlugin,
  FormPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTextareaPlugin,
  ListGroupPlugin,
  ModalPlugin,
  FormSpinbuttonPlugin,
  SidebarPlugin,
  TabsPlugin,
  VBTooltip,
} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueToast from 'vue-toast-notification';
import store from './store';
import VisualSchedule from './VisualSchedule.vue';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(AlertPlugin);
Vue.use(BadgePlugin);
Vue.use(BootstrapVueIcons);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(ImagePlugin);
Vue.use(InputGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(ModalPlugin);
Vue.use(ListGroupPlugin);
Vue.use(SidebarPlugin);
Vue.use(TabsPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormSpinbuttonPlugin);
Vue.directive('b-tooltip', VBTooltip);
Vue.use(VueToast);
Vue.component('v-select', vSelect);

export default (visualScheduleShow) => {
  const props = JSON.parse(visualScheduleShow.getAttribute('data'));
  new Vue({
    store,
    render: (h) => h(VisualSchedule, { props }),
  }).$mount('#visual-schedule-show');
};
